module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/hospital-cee87343121c24b79fd6ee6c72fe4ddb.svg";